<template>
    <button
        data-cy="jump-to-nav-item"
        class="nav-option"
        :class="{ 'is-open': isOpen, expanded }"
        :aria-label="label"
        :aria-expanded="isOpen.toString()">
        <div
            class="nav-icon"
            data-cy="jump-to-trigger-icon">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="var(--icon-stroke-base)"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round">
                <circle
                    cx="12"
                    cy="17"
                    r="1" />
                <path d="M21 7v6h-6" />
                <path d="M3 17a9 9 0 0 1 9-9 9 9 0 0 1 6 2.3l3 2.7" />
            </svg>
        </div>
        <div
            v-show="expanded"
            data-cy="jump-to-label"
            class="jump-to-label">
            <div class="label-text">
                {{ label }}
            </div>
            <div class="keyboard-shortcut">
                {{ keyboardShortcut }}
            </div>
        </div>
    </button>
</template>

<script>
export default {
    name: 'JumpToNavItem',
    props: {
        isOpen: {
            type: Boolean,
            default: false,
        },
        expanded: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        label () {
            return this.$t('sideNav.Go to page');
        },
        isMac () {
            return navigator.userAgent.toLowerCase().includes('mac');
        },
        keyboardShortcut () {
            const keyboardShortcut = this.isMac ? '⌘' : 'Ctrl+Alt';

            return this.$t('sideNav.{keyboardShortcut}+K', { keyboardShortcut });
        },
    },
};
</script>

<style scoped lang="less">
@import '@/side-nav/nav.style.less';

.jump-to-label {
    display: flex;
    align-items: center;
    overflow: hidden;
    flex-grow: 1;
    gap: 8px;
    padding-right: 4px;
}

.label-text {
    flex-grow: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.keyboard-shortcut {
    color: var(--text-body-subtle-base);
    font-size: 12px;
    flex-shrink: 0;
    margin-top: 1px;
}
</style>
